<tgf-payment-form-credit-card-widget
  *ngIf="isCreditCardPayment()"
  [parentModel]="actualModel">
</tgf-payment-form-credit-card-widget>
<tgf-payment-form-telecheck-widget
  (switchedToCreditCard)="switchToCreditCard()"
  *ngIf="isTelecheckPayment()"
  [parentModel]="actualModel">
</tgf-payment-form-telecheck-widget>
<tgf-form-control-question-processor
  [parentModel]="actualModel"
  [form]="questionForm" [questionJson]="questionJson"
  [questionsToInclude]="['ECControlNumber', 'AssociationRequestID']"
>
</tgf-form-control-question-processor>

<tg-spinner *ngIf="isItLoading()"></tg-spinner>
